import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=c3211e96&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=c3211e96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3211e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3211e96')) {
      api.createRecord('c3211e96', component.options)
    } else {
      api.reload('c3211e96', component.options)
    }
    module.hot.accept("./CommentInput.vue?vue&type=template&id=c3211e96&scoped=true", function () {
      api.rerender('c3211e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/share/CommentInput.vue"
export default component.exports